"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PromptSuggestionCard = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
var _sparklesFilled = _interopRequireDefault(require("@ux/icon/sparkles-filled"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ConversationalSearch = require("../styles/ConversationalSearch");
const PromptSuggestionCard = ({
  isSelected = false,
  promptSuggestion,
  listId,
  updateSelection
}) => {
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  const formattedMessage = formatMessage({
    id: promptSuggestion
  });
  const onClickHandler = () => {
    updateSelection(listId, formattedMessage);
  };
  return /*#__PURE__*/_react.default.createElement("button", {
    "data-cy": `prompt-suggestion-card-${listId}`,
    "data-testid": `prompt-suggestion-card-${listId}`,
    className: (0, _classnames.default)('prompt-suggestion-card ms-1 d-flex flex-column justify-content-between align-items-start align-self-stretch', {
      'prompt-suggestion-card-selected': isSelected
    }),
    onClick: onClickHandler
  }, /*#__PURE__*/_react.default.createElement(_sparklesFilled.default, {
    fill: isSelected ? 'white' : _ConversationalSearch.COLOR_AI_PURPLE
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "prompt-suggestion-card-text"
  }, formattedMessage));
};
exports.PromptSuggestionCard = PromptSuggestionCard;
PromptSuggestionCard.propTypes = {
  isSelected: _propTypes.default.bool,
  promptSuggestion: _propTypes.default.string.isRequired,
  listId: _propTypes.default.number.isRequired,
  updateSelection: _propTypes.default.func.isRequired
};